import { useDispatch, useSelector } from 'react-redux';
import { Box, Text } from '@quintoandar-tokko/jopijs';
import { PROPERTY_OPERATIONS } from '@/components/Dashboard/constants';
import { formatValue } from '../utils';
import styles from '../totalValueCard.module.scss';
import { showQuickDisplay } from '@/store/slices/components/quickDisplay/QuickDisplaySlice';

export default function CurrencyValuesInformation() {
  const dispatch = useDispatch();
  const { sale, rent, selectedCurrency, selectedOperation } = useSelector(
    (state) => state.DashboardSlice.overviewOperationStatistics
  );
  const operation =
    selectedOperation === PROPERTY_OPERATIONS.SALE ? sale : rent;

  const totalValue = operation[selectedCurrency]?.total_price;
  const maxValue = operation[selectedCurrency]?.maximum;
  const minValue = operation[selectedCurrency]?.minimum;

  const totalValueText = `${selectedCurrency} ${formatValue(totalValue)}`;
  const maxValueText = `${selectedCurrency} ${formatValue(maxValue)}`;
  const minValueText = `${selectedCurrency} ${formatValue(minValue)}`;

  const targetMinPropertyId =
    operation[selectedCurrency]?.minimum_price_property_id;
  const targetMaxPropertyId =
    operation[selectedCurrency]?.maximum_price_property_id;

  const isMaxValueZero = Number(maxValue) === 0;
  const isMinValueZero = Number(minValue) === 0;

  const handleMaxValueClick = () => {
    if (!isMaxValueZero) {
      dispatch(showQuickDisplay({ id: targetMaxPropertyId }));
    }
  };

  const handleMinValueClick = () => {
    if (!isMinValueZero) {
      dispatch(showQuickDisplay({ id: targetMinPropertyId }));
    }
  };

  return (
    <>
      <Text className={styles.mainValue}>{totalValueText}</Text>
      <Box className={styles.labelAndValue}>
        <Text className={styles.label}>Max:</Text>
        <Text
          className={`${styles.value} ${styles.maxValue} ${
            isMaxValueZero ? styles.disabledValue : ''
          }`}
          onClick={handleMaxValueClick}
        >
          {maxValueText}
        </Text>
      </Box>
      <Box className={styles.labelAndValue}>
        <Text className={styles.label}>Min:</Text>
        <Text
          className={`${styles.value} ${styles.minValue} ${
            isMinValueZero ? styles.disabledValue : ''
          }`}
          onClick={handleMinValueClick}
        >
          {minValueText}
        </Text>
      </Box>
    </>
  );
}
